import React from 'react';
import { ConfigProvider, useConfigContext } from './config';
import { GlobalProvider, useGlobalContext } from './global';
import { StaffProvider, useStaffContext } from './staff';
import { DataProvider, useDataContext } from './data';

export {
    ConfigProvider,
    useConfigContext,
    useGlobalContext,
    useStaffContext,
    useDataContext
};

const CombineComponents = (components) => (
    components.reduce((AccumulatedComponents, CurrentComponent) => (
        ({ children }) => (
            <AccumulatedComponents>
                <CurrentComponent>
                    {children}
                </CurrentComponent>
            </AccumulatedComponents>
        )
    ), ({ children }) => children)
);

const StoreProvider = CombineComponents([
    ConfigProvider,
    GlobalProvider,
    StaffProvider,
    DataProvider
]);

export default StoreProvider;
